import { createMuiTheme }  from '@material-ui/core/styles'
const muiTheme = createMuiTheme({
})
export default muiTheme
